import React from 'react';
import PromissoryNoteGroup from './PromissoryNoteGroup';
import './index.scss';
import PromissoryNoteIndividual from './PromissoryNoteIndividual';
import { letter } from '../DocumentPaperLetter';

const DocumentPromissoryNote = () => {
  const requisition = JSON.parse(localStorage.getItem('requisition'));

  const isGroup = requisition.Grupo.Socios.length > 1;

  if (isGroup) {
    return (
      <>
        <PromissoryNoteGroup requisition={requisition} />

        {requisition?.Grupo.Socios.map((socio, index) => (
          <div
            key={index}
            className={`${index % 2 ? 'afterClass' : ''}`}
            style={{
              height: `${(letter.HEIGHT - 1.3 * 3) / 2}cm`,
              position: 'relative',
              marginBottom: index % 2 ? '0cm' : '1.3cm',
            }}
          >
            <div
              style={{
                position: 'absolute',
                top: '50%',
                transform: 'translateY(-50%)',
              }}
            >
              <PromissoryNoteIndividual
                key={index}
                client={socio}
                guarantor={
                  requisition?.Grupo.Socios[index + 1]
                    ? requisition?.Grupo.Socios[index + 1]
                    : requisition?.Grupo.Socios[0]
                }
                requisition={requisition}
              />
            </div>
          </div>
        ))}
      </>
    );
  }

  return (
    <PromissoryNoteIndividual
      client={requisition?.Grupo.Socios[0]}
      guarantor={requisition?.Grupo.aval}
      requisition={requisition}
    />
  );
};

export default DocumentPromissoryNote;
